import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { postIdlingConsumptionObservation } from '../../../../../actions';
import { IDLING_CONSUMPTION_ENDPOINT } from '../../../../../config/endpoints';
import { POST } from '../../../../../config/permissions';
import Modal from '../../../../common/modal/Modal';
import IdlingConsumptionForm from './IdlingConsumptionForm';

export const IdlingConsumptionButton = ({
  itineraryId,
  dispatchPostIdlingConsumptionObservation,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');

  const onModalSubmit = (formValues) => {
    const newFormValues = {
      ...formValues,
      idlingConsumptionMotiveId: formValues.idlingConsumptionMotiveId
        ? formValues.idlingConsumptionMotiveId.value
        : null,
    };

    dispatchPostIdlingConsumptionObservation(itineraryId, newFormValues);
  };
  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const buildModalBody = () => {
    const newModalBody = (
      <IdlingConsumptionForm
        onCancel={closeModal}
        handleProcess={onModalSubmit}
      />
    );
    setModalBody(newModalBody);
  };

  useEffect(() => {
    if (showModal !== false) {
      buildModalBody();
    }
  }, [showModal]);

  return (
    <>
      <Modal
        show={showModal}
        title="Consumo Ralenti"
        body={modalBody}
        size="lg"
      />
      <Button color="warning" className="border" onClick={openModal}>
        <i className="fa fa-tachometer" /> Consumo Ralenti
      </Button>
    </>
  );
};

IdlingConsumptionButton.propTypes = {
  itineraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  dispatchPostIdlingConsumptionObservation: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostIdlingConsumptionObservation: postIdlingConsumptionObservation,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(IdlingConsumptionButton);

export default withEndpointAuthorization({
  url: IDLING_CONSUMPTION_ENDPOINT,
  mapUrlParamsToProps: { itineraryId: 'itineraryId' },
  permissionType: POST,
})(connectedComponent);
